// @flow
import pickBy from 'lodash/pickBy'

// $FlowFixMe
export const cleanObject = (obj: Object) => {
  return pickBy(obj, (v) => v !== undefined)
}
